/** Money arrives from the API as integer pesewas. Formatting happens here, once. */

export function ghs(pesewas, { symbol = true } = {}) {
  const n = Number(pesewas) || 0;
  const neg = n < 0;
  const abs = Math.abs(Math.round(n));
  const whole = String(Math.floor(abs / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  const frac = String(abs % 100).padStart(2, '0');
  return `${neg ? '-' : ''}${symbol ? 'GHS ' : ''}${whole}.${frac}`;
}

export function toPesewas(input) {
  const s = String(input ?? '').trim().replace(/[^0-9.]/g, '');
  if (!s) return 0;
  const [whole, frac = ''] = s.split('.');
  return Number(whole || 0) * 100 + Number((frac + '00').slice(0, 2));
}

export const minutes = m => (m ? `${m} min` : '');
